import { render, staticRenderFns } from "./ColorListItem.vue?vue&type=template&id=493610a6&scoped=true"
import script from "./ColorListItem.vue?vue&type=script&lang=js"
export * from "./ColorListItem.vue?vue&type=script&lang=js"
import style0 from "./ColorListItem.vue?vue&type=style&index=0&id=493610a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493610a6",
  null
  
)

export default component.exports